import { render, staticRenderFns } from "./ExamDeleteOption.vue?vue&type=template&id=cda56b9a&scoped=true"
import script from "./ExamDeleteOption.vue?vue&type=script&lang=js"
export * from "./ExamDeleteOption.vue?vue&type=script&lang=js"
import style0 from "./ExamDeleteOption.vue?vue&type=style&index=0&id=cda56b9a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cda56b9a",
  null
  
)

export default component.exports